import { Actions } from '../../interfaces/redux.interface';
import { types } from '../types';

import { InfoSession } from '../../api/session';

export const initialState : any = {
    info: InfoSession(),
};

export const authReducer = (state = initialState, action: Actions) => {
    switch (action.type) {
        case types.login:
            return {
                info: action.payload.infoSession,
            };
        case types.logout:
            return {};

        default:
            return state;
    }
};
